export default __webpack_public_path__ + "static/media/234.38d25110.svg";